import React from 'react'

import { TreeCollapsible } from './TreeCollapsible'
import { TreeCollapsibleContent } from './TreeCollapsibleContent'
import { TreeCollapsibleTrigger } from './TreeCollapsibleTrigger'
import { TreeIcon } from './TreeIcon'
import { TreeItem } from './TreeItem'
import { TreeList } from './TreeList'
import { TreeText } from './TreeText'

type TreeProps = React.ComponentProps<typeof TreeList>

export const TreeRoot = React.forwardRef<HTMLUListElement, TreeProps>(
  ({ children, ...rest }, ref) => {
    return (
      <TreeList {...rest} ref={ref} role="tree">
        {children}
      </TreeList>
    )
  }
)

export const Tree = Object.assign(TreeRoot, {
  Collapsible: TreeCollapsible,
  CollapsibleContent: TreeCollapsibleContent,
  CollapsibleTrigger: TreeCollapsibleTrigger,
  Item: TreeItem,
  Icon: TreeIcon,
  Text: TreeText
})
